import React from "react";
import cx from "classnames";

interface DropdownViewProps {
  active: boolean;
  distance?: number;
  children: React.ReactNode;
}

const DropdownView: React.FC<DropdownViewProps> = ({
  active,
  distance = 0,
  children,
}) => {
  return (
    <div
      className={cx(
        "absolute z-50 bg-white rounded-b-xl w-full overflow-hidden",
        "scrollbar-hide transition-all duration-200",
        active ? "opacity-100 visible" : "opacity-0 invisible"
      )}
      style={{
        transform: `translateY(${distance}px)`,
        maxHeight: active ? "70vh" : "0",
        overflowY: "auto",
      }}
    >
      <div className="p-2">{children}</div>
    </div>
  );
};

export default DropdownView;